export const OrangeArrow = (
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.510294 0.829193L1.32588 0.0143747L5.76818 4.45514C5.83979 4.52629 5.89662 4.61091 5.9354 4.70411C5.97418 4.79732 5.99414 4.89727 5.99414 4.99822C5.99414 5.09917 5.97418 5.19912 5.9354 5.29233C5.89662 5.38553 5.83979 5.47015 5.76818 5.54131L1.32588 9.98438L0.511063 9.16956L4.68048 4.99937L0.510294 0.829193Z"
      fill="#ED5E2A"
    />
  </svg>
);
